import { render, staticRenderFns } from "./FinanceExpenses.vue?vue&type=template&id=44284f54"
import script from "./FinanceExpenses.vue?vue&type=script&lang=js"
export * from "./FinanceExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports